export default __webpack_public_path__ + "static/media/microscope.225e143a.mp3";